import React from "react";
import Main from "../components/main";

export default function DataAnalytics() {
  return (
    <>
      <head>
        <title>IT Training in Pokhara | Java, Python, Data Science, AI, ML</title>
        <meta
          name="description"
          content="Best IT training in Pokhara for Java, Python, Data Science, AI, and Machine Learning. Enhance your career with expert-led courses at Dakshya A.I."
        />
        <meta
          name="keywords"
          content="IT training Pokhara, Java course Pokhara, Python, Data Science, Machine Learning, AI, Full stack development, Programming training Pokhara, Dakshya A.I."
        />
        <meta name="author" content="Dakshya A.I." />
        <meta name="robots" content="index, follow" />
      </head>

      <Main>
        <div className="container py-5">
        <h1 className="text-center mb-4 fw-bold">
    Best Java & IT Training in Pokhara – Dakshya A.I.
  </h1>

          <div className="mb-5">
            <h2 className="h4 fw-semibold mb-3">Why Choose Dakshya A.I?</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ 18 Years of Programming Excellence – Beginner to Professional</li>
              <li className="list-group-item">✅ 100% Internship & Placement Support</li>
              <li className="list-group-item">✅ Affordable & High-Quality Training</li>
              <li className="list-group-item">✅ Flexible courses from beginner to advanced</li>
            </ul>
          </div>

          <div className="mb-5">
            <h2 className="h4 fw-semibold mb-3">Popular Courses</h2>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li>📌 Java with Spring Framework</li>
                  <li>📌 Python with Data Science, AI, and Django</li>
                  <li>📌 React</li>
                  <li>📌 Flutter & React Native</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li>📌 AI & Machine Learning</li>
                  <li>📌 Full Stack Development (React + Java/Python)</li>
                  <li>📌 Web & Mobile App Development</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mb-5">
            <h2 className="h4 fw-semibold mb-3">
              Why Learning Java in Pokhara with Dakshya A.I. is Your Best Career Move
            </h2>
            <p>
              Dakshya A.I. provides hands-on training in Java, Python, AI/ML, and full stack development
              tailored for both beginners and professionals. Learn from expert trainers with over 18 years
              of real-world experience and exposure to international markets.
            </p>
          </div>

          <div className="mb-5">
            <h2 className="h4 fw-semibold mb-3">Other Courses We Offer</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">Java Training – Beginner to Pro</li>
              <li className="list-group-item">Python Training – Beginner to Pro</li>
              <li className="list-group-item">Full Stack – MERN & Java</li>
              <li className="list-group-item">Web Development – React, Django</li>
              <li className="list-group-item">Mobile App – Flutter, React Native</li>
              <li className="list-group-item">Backend – Spring Boot, Django</li>
            </ul>
          </div>

          <div className="mb-5">
            <h2 className="h4 fw-semibold mb-3">What Makes Us Different?</h2>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Job-oriented real-world projects</li>
              <li className="list-group-item">✅ Focus on industry frameworks (Spring Boot, React, Django)</li>
              <li className="list-group-item">✅ Trainers with international experience</li>
              <li className="list-group-item">✅ Personalized mentorship</li>
              <li className="list-group-item">✅ Online + In-person options</li>
            </ul>
          </div>

          <div className="mb-5">
  <h2 className="h4 fw-semibold mb-3">Follow Us</h2>
  <div className="d-flex flex-wrap gap-3">
    <a
      href="https://www.instagram.com/dakshyaai"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none"
    >
       Instagram
    </a>
    <a
      href="https://www.youtube.com/@dakshyaa.i"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none"
    >
       YouTube
    </a>
    <a
      href="https://www.tiktok.com/@dakshyaai"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none"
    >
       TikTok
    </a>
    <a
      href="https://www.facebook.com/profile.php?id=100088380852723"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none"
    >
       Facebook
    </a>
    <a
      href="https://www.linkedin.com/company/dakshyaai/posts/?feedView=all"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none"
    >
       LinkedIn
    </a>
  </div>
</div>


          <div>
            <h2 className="h4 fw-semibold mb-3">Contact Us</h2>
            <p>Dakshya A.I. Pvt. Ltd.</p>
            <p>📍 Prithivi Chowk, Pokhara, Nepal</p>
            <p>📞 +977 981-4103736</p>
            <p>📲 WhatsApp: +977 981-4103736</p>
            <p>📧 info@dakshyaai.com</p>
          </div>
        </div>
      </Main>
    </>
  );
}
